<script setup lang="ts">
import { computed } from 'vue';
import { currency } from '@/utils/currency';
import { userPictureUrl } from '@/utils/user-picture-url';

interface Props {
  promotionalCode: PromotionalCode
}

const props = defineProps<Props>();

const earnings = computed(() => props.promotionalCode.completeRedeemsCount * props.promotionalCode.pricePerRedeem);

function handleShare() {
  const shareData = {
    text: `Hola! Si están pensando en arrendar equipos de nieve, les recomiendo hacerlo en Zirkular.cl ❄️
Usando el código ${props.promotionalCode.code} obtienen una botella de vino Castillo de Molina 🍷 al pagar \
la cuenta en Texas Ribs Patio Bellavista.`,
  };

  if (navigator.share && navigator.canShare(shareData)) {
    navigator.share(shareData);
  } else {
    navigator.clipboard.writeText(props.promotionalCode.code);
  }
}
</script>
<template>
  <div
    class="flex flex-col justify-between rounded border px-6 py-4 text-sm"
  >
    <div class="flex flex-col">
      <a
        :href="`/socio/${promotionalCode.partnerAccount.id}`"
        class="flex items-center space-x-1 text-z-gray-700 underline"
      >
        <img
          :src="userPictureUrl(promotionalCode.partnerAccount.pictureUrl)"
          class="h-4 w-4 rounded-full"
        >
        <p class="text-base text-z-gray-900">Tienda de {{ promotionalCode.partnerAccount.firstName }}</p>
      </a>
    </div>
    <div class="mt-4 flex flex-col md:grid md:grid-cols-2">
      <div>
        <p class="text-z-gray-700">
          Mi código
        </p>
        <p class="font-mono text-lg text-z-gray-900">
          {{ promotionalCode.code }}
        </p>
      </div>
      <div class="mt-4 md:mt-0">
        <p class="text-z-gray-700">
          Canjes completados
        </p>
        <p class="text-lg text-z-gray-900">
          {{ promotionalCode.completeRedeemsCount }}
          <span class="text-z-gray-700">-></span>
          {{ currency(earnings) }}
        </p>
      </div>
    </div>
    <base-button
      variant="secondary"
      size="sm"
      class="mt-4 space-x-2 md:hidden"
      @click="handleShare"
    >
      <p>Compartir código</p>
      <img src="@/assets/icons/share-rectangle.svg">
    </base-button>
  </div>
</template>
